import React, { useEffect, useState } from 'react';

const AppAds = () => {
  const [data, setData] = useState('');

  useEffect(() => {
    fetch('/app-ads.txt')   // file must be inside public folder
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch app-ads.txt');
        }
        return response.text();
      })
      .then((text) => {
        setData(text);
      })
      .catch((error) => {
        console.error(error);
        setData('Error loading file');
      });
  }, []);

  return (
    <div>
      <h2>app-ads.txt Content</h2>
      <pre>{data}</pre>
    </div>
  );
};

export default AppAds;